import { MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import { GQLMerchTileFragment, GQLProductSideSideType } from '@theprintbar/graphql';
import { WebRoutes, cn, getSortedMerchDecorations, invariant, withDomain } from '@theprintbar/shared';
import { useCallback } from 'react';
import { useGlobalPreview } from 'src/components/GlobalPreviewModal';

interface MerchPreviewProps {
	merch: GQLMerchTileFragment;
	colourCode?: string;
	className?: string;
	side?: GQLProductSideSideType;
	domain?: string;
	allowPreview?: boolean;
}

export function MerchPreview({ merch, colourCode, className, domain, allowPreview }: MerchPreviewProps) {
	const { side } = getSortedMerchDecorations(merch)[0];
	invariant(side, 'No main side found');

	const preview = useGlobalPreview();
	const openPreview = useCallback(() => {
		if (!allowPreview) return;
		preview.openPreview({
			merch,
			colourCode,
		});
	}, [allowPreview, merch, colourCode, domain, preview]);

	return (
		<div
			onClick={openPreview}
			className={cn(
				'overflow-hidden relative border border-blue w-24 h-24 lg:w-28 lg:h-28 rounded-3xl shadow-md',
				allowPreview && 'hover:cursor-pointer',
				className,
			)}
		>
			<img
				loading="lazy"
				src={withDomain(
					WebRoutes.API.images.merchImage({
						merchId: merch.id,
						side: side.side,
						colourCode: colourCode || merch.preferedColourCode,
						updatedAt: merch.updatedAt,
					}),
					domain,
				)}
			/>
			{allowPreview && <MagnifyingGlassPlusIcon className="w-4 h-4 absolute bottom-2 right-2" />}
		</div>
	);
}
